<script setup>
const props = defineProps({
  loading: Boolean,
})
</script>

<template>
  <button
    class="btn btn-primary"
    title="Salva"
  >
    <span v-if="!loading"> Salva </span>
    <span v-else-if="loading"
          class="spinner-border spinner-border-sm"
          role="status"
          aria-hidden="true">
    </span>
  </button>
</template>

<style scoped>

</style>
